import {useState, useEffect} from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_URL } from '../../config/api';

import Password from '../../components/ui/Input/Password'
import Button from '../../components/ui/Button';

import Alfredo from '../../assets/imagens/Alfredo.png'

import './RedefinicaoDeSenha.css'
import CodeRain from '../../components/CodeRain';

export default function RedefinicaoDeSenha(){
    const [senhaNova, setSenhaNova] = useState("")
    const [senhaConfirmada, setSenhaConfirmada] = useState("")
    const [searchParams] = useSearchParams()
    const [erroMensagem, setErroMensagem] = useState()

    const navigate = useNavigate()

    const senhasIguais = 
        senhaConfirmada !== "" && senhaNova === senhaConfirmada

    const token = searchParams.get("token")
    console.log(token)

    const redefinirSenha = async () => {
        try {
            const response = await fetch(
                `${API_URL}/reset-password`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        token: token,
                        newPassword: senhaNova
                    })
                }
            )

            const mensagem = await response.text()

            if (!response.ok) {
                throw new Error(mensagem)
            }

            alert("Senha alterada com sucesso!")
            navigate('/login')

        } catch (error) {
            console.error("Erro:", error.message)
            setErroMensagem(error.message)
            console.log(erroMensagem)
        }
}

    return (
        <div className='containerDefault containerRedefinicaoSenha'>
            <CodeRain />
             <div className='redefinicaoSenha'>
                <img className='avatarAlfredo' width={200} src={Alfredo} />
                
                <div>
                    <div className="redefinicaoSenhaTexto">
                        <h1>Insira uma nova senha</h1>

                        <p>A senha deverá conter no mínimo 10 caracteres</p>
                    </div>
                    <div className='redefinicaoSenhaInput'>
                        <Password 
                            name="Nova senha"
                            value={senhaNova}
                            placeholder="Digite uma senha"
                            onChange={(e)=>setSenhaNova(e.target.value)}
                            label="Digite uma nova senha"
                            required
                        />
                        <Password 
                            name="Confirme sua senha"
                            value={senhaConfirmada}
                            placeholder="Digite uma nova senha"
                            onChange={(e)=>setSenhaConfirmada(e.target.value)}
                            label="Confirme sua senha"
                            required
                        />
                       <div>
                            {senhaConfirmada !== "" && !senhasIguais && (
                                <p  className='erroMensagem'>
                                    As senhas não coincidem.
                                </p>
                            )}
                            {erroMensagem &&
                                <p className='erroMensagem'>{erroMensagem}</p>
                            }

                       </div>
                        <Button 
                            text="Confirmar"
                            onClick={()=> redefinirSenha()}
                            className="btnAmarelo"
                        />
                    </div>

                </div>

             </div>

        </div>
    )
}